import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DotLoader } from '@src/shared/feedback/loader/dot-loader.component';
import { ProgressBar } from '@src/shared/presentational/progress_bar/progress-bar.component';

@Component({
  selector: 'woo-progress-content',
  imports: [CommonModule, DotLoader, ProgressBar],
  templateUrl: './progress-content.component.html',
  styleUrl: './progress-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressContentComponent {
  message = input<string>();
  progress = input<number>();
  progress_message = input<string>();
}
